/**
 * 商品
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";
import * as types from "../../../mutation-types/backyard-types";

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/orders`

const order_detail = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    fetchAll({ _commit }, { order_id, params }) {
      const api_path = `${API_PATH}/${order_id}/order_details`
      return new Promise((resolve, _reject) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    edit({ _commit }, { order_id, id }) {
      const api_path = `${API_PATH}/${order_id}/order_details/${id}/edit`
      return new Promise((resolve, _reject) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    update( { commit }, { order_id, params } ) {
      const api_path = `${API_PATH}/${order_id}/order_details/${params.id}`
      return new Promise( ( resolve, _reject) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default order_detail